/**
 * @file
 * Dark theme.
 */
const currentTheme = localStorage.getItem("theme");
if (currentTheme) {
  document.documentElement.setAttribute("data-bs-theme", currentTheme);
}